module.exports = __webpack_public_path__ + "img/download.712ccf13.svg";